import './App.css';
import './styles/webview.css';
import './styles/pwa-mobile.css';
import Router from "./router/Router";
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { useEffect } from 'react';
import { setupWebViewCompatibility, debugWebView } from './utils/webview';
import { initializePWA } from './utils/pwa';

function App() {
  useEffect(() => {
    // Setup web view compatibility
    setupWebViewCompatibility();
    
    // Initialize PWA features
    const pwaInfo = initializePWA();
    console.log('PWA Mode:', pwaInfo);
    
    // Debug webview information (only in development)
    if (process.env.NODE_ENV === 'development') {
      setTimeout(() => {
        debugWebView();
      }, 1000);
    }
  }, []);

  return (
    <Router />
  );
}

export default App;
